export default function membershipToggle() {
    const toggle = document.querySelector('.gh-membership-toggle');
    if (!toggle) return;

    const tiers = document.querySelector('.gh-membership-tiers');
    const buttons = toggle.querySelectorAll('button');

    // Calculate and display discount percentages
    document.querySelectorAll('.js-discount').forEach(el => {
        const priceEl = el.closest('.gh-membership-price');
        const monthly = parseInt(priceEl.dataset.monthly, 10);
        const yearly = parseInt(priceEl.dataset.yearly, 10);
        if (monthly && yearly) {
            const discount = Math.round(100 - (yearly / (monthly * 12)) * 100);
            if (discount > 0) {
                el.textContent = `${discount}% off`;
            }
        }
    });

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            const interval = btn.dataset.interval;

            buttons.forEach(b => {
                b.classList.remove('active');
                b.setAttribute('aria-selected', 'false');
            });
            btn.classList.add('active');
            btn.setAttribute('aria-selected', 'true');

            tiers.classList.toggle('show-yearly', interval === 'yearly');
        });
    });
}
